module.exports = __webpack_public_path__ + "media/trail_of_the_lotus_blossom.22198df9.webm";